import { provide, useDependencies } from '@servicetitan/react-ioc';
import { Loader } from '@servicetitan/web-components';
import { observer } from 'mobx-react';
import { FieldsSettingsStore } from '../stores/fields-settings.store';

export const FieldsSettingsPage = provide({ singletons: [FieldsSettingsStore] })(
    observer(() => {
        const [{ source, data, basename }] = useDependencies(FieldsSettingsStore);

        return <Loader src={source} data={data} basename={basename} />;
    }),
);
